import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MailboxDetailView } from '../../models/mailbox-detail-view.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-mailbox-detail-left-column',
    styleUrls: ['./mailbox-detail-left-column.component.scss'],
    templateUrl: './mailbox-detail-left-column.component.html',
    standalone: false
})
export class MailboxDetailLeftColumnComponent {
   @Output() editMailboxPinClick = new EventEmitter<void>();

   @Input() get mailbox(): MailboxDetailView | null {
      return this._mailbox;
   }
   @Input() extensionType: string | null;

   set mailbox(value: MailboxDetailView | null) {
      this._mailbox = value;
   }
   get isSmartVoicemail(): boolean {
      return this.mailbox?.extension?.extensionType?.name === 'SmartVoicemail';
   }

   private _mailbox: MailboxDetailView | null;

   get formattedEmailAddress(): string[] {
      return this._mailbox?.emailAddress?.split(',') || [];
   }

   onEditMailboxPinClick() {
      this.editMailboxPinClick.emit();
   }
}
